import { render, staticRenderFns } from "./region-selection.vue?vue&type=template&id=d2b2c47e"
import script from "./region-selection.vue?vue&type=script&lang=ts"
export * from "./region-selection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports